<div class="wrapper-body analytics-page" *ngIf="!noAccess">
  <div class="page-header d-flex align-items-center justify-content-between mb-4">
    <h3 class="m-0 font-weight-bold">Analytics & Insights</h3>
  </div>

  <div class="card shadow-sm border-0 mb-4 rounded p-3 filter-panel">
    <form class="custom-form mb-0">
      <div class="row align-items-end mb-0">
        <div class="col-lg-2 col-md-4 mb-3">
          <label class="mb-1 text-muted small font-weight-bold">Location</label>
          <select class="custom-input w-100 mb-0" [(ngModel)]="filters.locationId" [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null">All Locations</option>
            <option *ngFor="let location of locations" [ngValue]="location.id">{{ location.name }}</option>
          </select>
        </div>
        <div class="col-lg-2 col-md-4 mb-3">
          <label class="mb-1 text-muted small font-weight-bold">Status</label>
          <select class="custom-input w-100 mb-0" [(ngModel)]="filters.status" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let status of statuses" [ngValue]="status">{{ status }}</option>
          </select>
        </div>
        <div class="col-lg-2 col-md-4 mb-3">
          <label class="mb-1 text-muted small font-weight-bold">Type</label>
          <select class="custom-input w-100 mb-0" [(ngModel)]="filters.scheduleType" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let scheduleType of scheduleTypes" [ngValue]="scheduleType">{{ scheduleType }}</option>
          </select>
        </div>
        <div class="col-lg-2 col-md-4 mb-3">
          <label class="mb-1 text-muted small font-weight-bold">From Date</label>
          <p-calendar
            [(ngModel)]="fromDateValue"
            [ngModelOptions]="{standalone: true}"
            [showIcon]="false"
            appendTo="body"
            dateFormat="dd-mm-yy"
            [showButtonBar]="true"
            [readonlyInput]="true"
            styleClass="w-100"
            panelStyleClass="analytics-datepicker-panel"
            inputStyleClass="custom-input bg-white mb-0">
          </p-calendar>
        </div>
        <div class="col-lg-2 col-md-4 mb-3">
          <label class="mb-1 text-muted small font-weight-bold">To Date</label>
          <p-calendar
            [(ngModel)]="toDateValue"
            [ngModelOptions]="{standalone: true}"
            [showIcon]="false"
            appendTo="body"
            dateFormat="dd-mm-yy"
            [showButtonBar]="true"
            [readonlyInput]="true"
            styleClass="w-100"
            panelStyleClass="analytics-datepicker-panel"
            inputStyleClass="custom-input bg-white mb-0">
          </p-calendar>
        </div>
        <div class="col-lg-2 col-md-4 mb-3">
          <label class="mb-1 text-muted small font-weight-bold d-block" style="visibility: hidden;">Actions</label>
          <div class="filter-actions">
            <button
              type="button"
              class="theme-button icon-action rounded shadow-sm"
              (click)="applyFilters()"
              title="Apply Filters"
              aria-label="Apply Filters">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 12.5l4 4L19 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button
              type="button"
              class="theme-button grey icon-action rounded shadow-sm"
              (click)="resetFilters()"
              title="Reset Filters"
              aria-label="Reset Filters">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M20 11a8 8 0 10-2.34 5.66M20 4v7h-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- KPI ROW -->
  <div class="row" *ngIf="show">
    <div class="col-xl-2 col-lg-4 col-md-4 col-sm-6 mb-4">
      <div class="card shadow-sm border-0 h-100 rounded p-3 kpi-card d-flex flex-column justify-content-center">
        <h6 class="text-muted mb-2 font-weight-bold" style="font-size: 0.85rem;" title="Total Revenue">Total Revenue</h6>
        <h3 class="mb-0 text-success font-weight-bold">$ {{ kpis.totalBilled }}</h3>
      </div>
    </div>
    <div class="col-xl-2 col-lg-4 col-md-4 col-sm-6 mb-4">
      <div class="card shadow-sm border-0 h-100 rounded p-3 kpi-card d-flex flex-column justify-content-center">
        <h6 class="text-muted mb-2 font-weight-bold" style="font-size: 0.85rem;" title="Total Received">Total Received</h6>
        <h3 class="mb-0 text-info font-weight-bold">$ {{ kpis.totalReceived }}</h3>
      </div>
    </div>
    <div class="col-xl-2 col-lg-4 col-md-4 col-sm-6 mb-4">
      <div class="card shadow-sm border-0 h-100 rounded p-3 kpi-card d-flex flex-column justify-content-center">
        <h6 class="text-muted mb-2 font-weight-bold" style="font-size: 0.85rem;" title="Outstanding">Outstanding</h6>
        <h3 class="mb-0 text-danger font-weight-bold">$ {{ kpis.totalOutstanding }}</h3>
      </div>
    </div>
    <div class="col-xl-2 col-lg-4 col-md-4 col-sm-6 mb-4">
      <div class="card shadow-sm border-0 h-100 rounded p-3 kpi-card d-flex flex-column justify-content-center">
        <h6 class="text-muted mb-2 font-weight-bold" style="font-size: 0.85rem;" title="Appointments">Appointments</h6>
        <h3 class="mb-1 text-primary font-weight-bold">{{ kpis.totalAppointments }}</h3>
        <small class="text-muted font-weight-bold" style="font-size: 0.75rem; cursor: help;" title="Includes CREATED, REVIEWED, and BACKGROUNDFORMSUBMIT statuses">{{ kpis.ongoingAppointments }} Ongoing</small>
      </div>
    </div>
    <div class="col-xl-2 col-lg-4 col-md-4 col-sm-6 mb-4">
      <div class="card shadow-sm border-0 h-100 rounded p-3 kpi-card d-flex flex-column justify-content-center">
        <h6 class="text-muted mb-2 font-weight-bold" style="font-size: 0.85rem;" title="BG Pending">BG Pending</h6>
        <h3 class="mb-0 text-warning font-weight-bold">{{ kpis.backgroundPendingCount }}</h3>
      </div>
    </div>
    <div class="col-xl-2 col-lg-4 col-md-4 col-sm-6 mb-4">
      <div class="card shadow-sm border-0 h-100 rounded p-3 kpi-card d-flex flex-column justify-content-center">
        <h6 class="text-muted mb-2 font-weight-bold" style="font-size: 0.85rem; cursor: help;" title="Calculated as: (Total Received / Total Billed) * 100">Collection Rate</h6>
        <h3 class="mb-0 text-success font-weight-bold">{{ kpis.collectionRate }}%</h3>
      </div>
    </div>
  </div>

  <!-- CHARTS ROW 1 -->
  <div class="row" *ngIf="show">
    <div class="col-lg-12 mb-4">
      <div class="card shadow-sm border-0 h-100 rounded p-4 analytics-main-chart">
        <h6 class="font-weight-bold mb-3">Financial Performance</h6>
        <div class="chart-panel" style="height: 350px;">
          <canvas baseChart [data]="financialChartData" [type]="'bar'" [options]="mainChartOptions"></canvas>
        </div>
      </div>
    </div>
  </div>

  <!-- CHARTS ROW 2 -->
  <div class="row" *ngIf="show">
    <div class="col-lg-8 mb-4">
      <div class="card shadow-sm border-0 h-100 rounded p-4 analytics-main-chart">
        <h6 class="font-weight-bold mb-3">Appointment Volume Trend</h6>
        <div class="chart-panel" style="height: 320px;">
          <canvas baseChart [data]="trendChartData" [type]="trendChartType" [options]="mainChartOptions"></canvas>
        </div>
      </div>
    </div>
    <div class="col-lg-4 mb-4">
      <div class="card shadow-sm border-0 h-100 rounded p-4 analytics-main-chart">
        <h6 class="font-weight-bold mb-3">Status Distribution</h6>
        <div class="chart-panel" style="height: 320px;">
          <canvas baseChart [data]="statusChartData" [type]="statusChartType" [options]="mainChartOptions"></canvas>
        </div>
      </div>
    </div>
  </div>

  <!-- CHARTS ROW 3 -->
  <div class="row" *ngIf="show">
    <div class="col-lg-6 mb-4">
      <div class="card shadow-sm border-0 h-100 rounded p-4">
        <h6 class="font-weight-bold mb-3">Appointments by Location</h6>
        <canvas baseChart [data]="locationChartData" [type]="locationChartType"></canvas>
      </div>
    </div>
    <div class="col-lg-6 mb-4">
      <div class="card shadow-sm border-0 h-100 rounded p-4">
        <h6 class="font-weight-bold mb-3">Top Diagnosticians</h6>
        <canvas baseChart [data]="diagnosticianChartData" [type]="diagChartType"></canvas>
      </div>
    </div>
  </div>

  <!-- TABLES ROW -->
  <div class="row" *ngIf="show">
    <div class="col-lg-6 mb-4">
      <div class="card shadow-sm border-0 h-100 rounded p-3 table-height table-container">
        <h6 class="font-weight-bold mb-3">Outstanding Payments</h6>
        <p *ngIf="outstandingPayments.length < 1" class="text-center text-muted py-3 mb-0">No Data</p>
        <div class="table-responsive" *ngIf="outstandingPayments.length > 0">
          <table class="table table-hover table-sm mb-0">
            <thead class="bg-light">
              <tr>
                <th class="border-top-0 border-bottom-0">Client</th>
                <th class="border-top-0 border-bottom-0 text-right">Total</th>
                <th class="border-top-0 border-bottom-0 text-right">Remaining</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of outstandingPayments">
                <td class="align-middle"><a [routerLink]="['/appt-all-details', item.appointmentId]" class="font-weight-bold text-decoration-none">{{ item.clientName }}</a></td>
                <td class="align-middle text-right">${{ item.totalAmount }}</td>
                <td class="align-middle text-danger text-right font-weight-bold">${{ item.remaining }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-lg-6 mb-4">
      <div class="card shadow-sm border-0 h-100 rounded p-3 table-height table-container">
        <h6 class="font-weight-bold mb-3">Background Form Pending</h6>
        <p *ngIf="backgroundPendingAppointments.length < 1" class="text-center text-muted py-3 mb-0">No Data</p>
        <div class="table-responsive" *ngIf="backgroundPendingAppointments.length > 0">
          <table class="table table-hover table-sm mb-0">
            <thead class="bg-light">
              <tr>
                <th class="border-top-0 border-bottom-0">Client</th>
                <th class="border-top-0 border-bottom-0">Appointment Date</th>
                <th class="border-top-0 border-bottom-0">Location</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of backgroundPendingAppointments">
                <td class="align-middle"><a [routerLink]="['/appt-all-details', item.appointmentId]" class="font-weight-bold text-decoration-none">{{ item.clientName }}</a></td>
                <td class="align-middle">{{ item.appointmentDate }}</td>
                <td class="align-middle">{{ item.location }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="wrapper-body" *ngIf="noAccess">
  <div class="card p-4 text-center">
    <h5 class="mb-2">Access Restricted</h5>
    <p class="mb-0">{{ message }}</p>
  </div>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple"></ngx-spinner>
